/* ★ SIMPAN HASIL AGENT KE CLOUD — satu kad, medan hasil sahaja (2026-10-13)
 *
 * Pasangan utils/hasilAgentKad.js (baca nota di sana dahulu). Menggantikan
 * `saveToCloud(working)` dalam larian pukal Agent Saya, yang menulis SELURUH kad
 * (REPLACE) daripada salinan lama dan memadam video / status / log yang ditulis
 * robot Flow di browser lain.
 *
 * Doc utama → `update` dengan laluan medan (corak utils/kosongkanPrompt.js):
 *   · medan yang tidak disebut TIDAK disentuh (video, poster, status, collection);
 *   · kad yang sudah dipadam di browser lain menggagalkan tulisan dengan jelas,
 *     bukannya lahir semula sebagai kad hantu;
 *   · log ditambah dengan arrayUnion (sama seperti robot) — log pihak lain kekal.
 * Subdoc teks (Split V2) → `set` merge, sama seperti laluan simpan biasa.
 *
 * ⚠️ KEMBAR: `MODUL_SIMPAN_RAWOUTPUT` = `RAWOUT_KEEP_MODULES` dalam
 *    services/productService.js + WorkspaceView.jsx. Module baharu yang menyimpan
 *    Full Prompt → tambah di KETIGA-TIGA tempat.
 */
import { db } from '../firebase';
import { doc, writeBatch, arrayUnion, serverTimestamp, FieldPath } from 'firebase/firestore';
import { productDetailDoc, splitProductForWrite, isSplitEnabled } from '../services/productService';

const MODUL_SIMPAN_RAWOUTPUT = new Set(['flownity', 'smartcustom']);

/* Firestore menolak `undefined` — buang daripada nilai bersarang (peta/senarai biasa sahaja). */
const bersih = (v) => {
    if (Array.isArray(v)) return v.filter(x => x !== undefined).map(bersih);
    if (v && typeof v === 'object' && v.constructor === Object) {
        const out = {};
        for (const [k, x] of Object.entries(v)) if (x !== undefined) out[k] = bersih(x);
        return out;
    }
    return v;
};

/**
 * @param uid       pemilik kad
 * @param kad       { id, moduleId } — kad yang baru disiapkan larian
 * @param hasil     keluaran `kiraHasilAgent` (bukan null)
 * @throws bila id/uid tiada atau Firestore menolak — pemanggil WAJIB memberitahu pelanggan.
 */
export async function simpanHasilAgent(uid, kad, hasil) {
    if (!uid || !kad?.id) throw new Error('simpanHasilAgent: uid / id kad tiada');
    if (!hasil) return;

    const pecah = isSplitEnabled();
    const { rawOutput, ...medanLain } = hasil.medan;
    const simpanRaw = typeof rawOutput === 'string'
        && MODUL_SIMPAN_RAWOUTPUT.has(String(kad.moduleId || '').toLowerCase());

    /* Pecah medan prompts yang berubah: sisi ringan (doc utama) lwn berat (subdoc).
       Suis pecah MATI → semuanya duduk dalam doc utama (perangai lama). */
    const { light, heavy, hasHeavy } = splitProductForWrite({
        prompts: hasil.prompts,
        ...(simpanRaw ? { rawOutput } : {}),
    });
    const promptsUtama = pecah ? (light.prompts || {}) : hasil.prompts;

    const medan = [];
    for (const [k, v] of Object.entries(medanLain)) medan.push(k, bersih(v));
    for (const [setKey, setData] of Object.entries(promptsUtama)) {
        for (const [f, v] of Object.entries(setData || {})) {
            medan.push(new FieldPath('prompts', setKey, f), bersih(v));
        }
    }
    if (!pecah && simpanRaw) medan.push('rawOutput', rawOutput);
    if (hasil.logBaru.length) medan.push('logs', arrayUnion(...hasil.logBaru));
    if (pecah) medan.push('splitV', 2);
    medan.push('lastUpdated', serverTimestamp());

    const batch = writeBatch(db);
    batch.update(doc(db, 'users', uid, 'products', kad.id), ...medan);
    if (pecah && hasHeavy) {
        batch.set(productDetailDoc(uid, kad.id), { ...bersih(heavy), updatedAt: serverTimestamp() }, { merge: true });
    }
    await batch.commit();
}
